module.exports = __webpack_public_path__ + "assets/mouse-flow.12cfc672.svg";